import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

// Masked line reveal — line sits in an overflow-hidden clip and slides up.
export function MaskLine({ children, delay = 0, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.2 });
  return (
    <span ref={ref} className="block overflow-hidden pb-[0.12em]">
      <motion.span
        className={"block will-change-transform " + className}
        initial={{ y: "115%" }}
        animate={inView ? { y: "0%" } : { y: "115%" }}
        transition={{ duration: 1, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

// Generic fade-up on scroll.
export function Reveal({ children, delay = 0, y = 32, className = "", as = "div" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.15 });
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </Comp>
  );
}

// Section eyebrow label with diamond + gold rule.
export function Eyebrow({ children, testid }) {
  return (
    <div data-testid={testid} className="flex items-center gap-3 text-gold/90">
      <span className="h-px w-8 bg-gold/50" />
      <span className="rotate-45 inline-block h-1.5 w-1.5 bg-gold" />
      <span className="font-sans text-[11px] sm:text-xs tracking-[0.3em] uppercase">
        {children}
      </span>
    </div>
  );
}
